"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _WebsiteConfiguration_1 = require("./_WebsiteConfiguration");
exports.PutBucketWebsiteInput = {
    type: "structure",
    required: ["Bucket", "WebsiteConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        WebsiteConfiguration: {
            shape: _WebsiteConfiguration_1._WebsiteConfiguration,
            locationName: "WebsiteConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "WebsiteConfiguration"
};
//# sourceMappingURL=PutBucketWebsiteInput.js.map